import { FiChevronRight, FiExternalLink } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import MichelProfileCard from './MichelProfileCard'
import NewsletterCard from './NewsletterCard'
import HackCard from '@presentation/components/ui/HackCard'
import LoadingSpinner from '@presentation/components/ui/LoadingSpinner'
import { useLatestHacks } from '@presentation/hooks/useLatestHacks'

export default function HacksSection() {
  const { hacks, loading, error } = useLatestHacks(3)

  return (
    <section className="box-border bg-background py-4 sm:py-6 lg:py-8">
      <div className="mx-auto flex max-w-7xl flex-col pl-8 pr-4 sm:pl-10 sm:pr-6 lg:pl-14 lg:pr-8">
        <div className="pl-2 sm:pl-4 lg:pl-5">
          <div className="flex shrink-0 items-center justify-between gap-4">
            <Link to="/hacks" className="no-underline">
              <h2 className="text-2xl font-bold tracking-tight text-blue sm:text-3xl">
                Michel&apos;s PD Hacks
              </h2>
            </Link>
            <Link
              to="/hacks"
              aria-label="View all Michel's PD Hacks"
              className="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-blue px-3 py-2 text-sm font-semibold text-blue no-underline transition-colors hover:border-blue hover:bg-blue/8"
            >
              View all
              <FiExternalLink className="size-4" aria-hidden="true" />
            </Link>
          </div>
          <div className="mt-3 h-0.5 w-full bg-blue" />
        </div>

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-[3fr_1fr]">
          <div className="flex flex-col">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {loading ? (
                <div className="sm:col-span-2 lg:col-span-3">
                  <LoadingSpinner />
                </div>
              ) : error ? (
                <p className="sm:col-span-2 lg:col-span-3 text-sm font-semibold text-text-secondary">
                  Unable to load Michel&apos;s hacks right now.
                </p>
              ) : hacks.length === 0 ? (
                <p className="sm:col-span-2 lg:col-span-3 text-sm font-semibold text-text-secondary">
                  No hacks available yet.
                </p>
              ) : (
                hacks.map((hack, index) => (
                  <div key={hack.uid} className={index >= 2 ? 'hidden sm:block' : undefined}>
                    <HackCard hack={hack} />
                  </div>
                ))
              )}
            </div>

            <div className="mt-4 flex shrink-0 justify-center sm:hidden">
              <Link
                to="/hacks"
                aria-label="See more Michel's PD Hacks"
                className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue px-4 py-3 text-center text-sm font-semibold leading-tight text-white no-underline shadow-sm transition-[transform,opacity,background-color] duration-200 hover:scale-[1.02] hover:bg-blue/90 hover:opacity-90 sm:text-base"
              >
                See more Michel&apos;s PD Hacks
                <FiChevronRight className="size-4" aria-hidden="true" />
              </Link>
            </div>

            <div className="mt-4 hidden shrink-0 justify-center sm:mt-6 sm:flex">
              <Link
                to="/hacks"
                aria-label="See more Michel's PD Hacks"
                className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue px-4 py-3 text-center text-sm font-semibold leading-tight text-white no-underline shadow-sm transition-[transform,opacity,background-color] duration-200 hover:scale-[1.02] hover:bg-blue/90 hover:opacity-90 sm:text-base"
              >
                See more Michel&apos;s PD Hacks
                <FiChevronRight className="size-4" aria-hidden="true" />
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <MichelProfileCard />
            <NewsletterCard />
          </div>
        </div>
      </div>
    </section>
  )
}
